<div class="container-fluid" style="max-width: 1200px;">
    <h1 class="m-3 display-6 vm-container-header">Distribution Centers</h1>

    <div class="pb-5">
        <div class="m-3 p-2 bg-body-light rounded-3 shadow">
            <div class="m-2">
                <form>
                    <div class="mb-3 row align-items-center">
                        <div class="col-sm-auto">
                            <select (change)="this.onCustomerChange($event)" aria-label="Select a customer" class="form-select">
                                <option value="" [selected]="!this.customerId">Select a Customer</option>
                                @for (entity of this.customers; track entity.id; ) {
                                    <option value="{{ entity.id }}" [selected]="entity.id === this.customerId">{{ entity.name }}</option>
                                }
                            </select>
                        </div>

                        <app-table-search [(value)]="this.service.searchTerm" />

                        <div class="col-sm-auto">
                            <div class="form-check form-switch mb-0">
                                <input id="include-inactive" class="form-check-input shadow-none" type="checkbox" role="switch" name="includeInactive" [(ngModel)]="this.service.includeInactive">
                                <label class="form-check-label" for="include-inactive">Include inactive Distribution Centers</label>
                            </div>
                        </div>
                    </div>
                </form>

                @if (!this.customerId) {
                    <div class="card text-center bg-info-subtle border border-info rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-info-circle-fill me-2"></i>Select a customer to see its Distribution Centers.
                        </div>
                    </div>
                } @else if (loading()) {
                    <div class="d-flex justify-content-center align-items-center gap-2 p-5 text-body-secondary" role="status">
                        <span class="spinner-border text-primary"></span>
                        <span>Loading distribution centers...</span>
                    </div>
                } @else if (((this.total$ | async) ?? 0) > 0) {
                    <table class="table table-striped table-hover">
                        <caption>
                            <div class="d-flex justify-content-between align-items-center">
                                <span>{{ this.total$ | async }} Total</span>
                                <button type="button" class="btn btn-sm btn-outline-primary" (click)="onAdd()" aria-label="Add distribution center">
                                    <i class="bi bi-building-add"></i>
                                </button>
                            </div>
                        </caption>

                        <thead>
                        <tr>
                            <th scope="col">Trading Partner</th>
                            <th (sort)="this.onSort($event)" scope="col" sortable="name">Name</th>
                            <th (sort)="this.onSort($event)" scope="col" sortable="address1">Address</th>
                            <th scope="col">Identifiers</th>
                            <th scope="col" class="text-center">Active</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>

                        <tbody class="table-group-divider">
                            @for (element of this.service.data$ | async; track element.id; ) {
                                <tr>
                                    <td class="align-middle">{{ element.tradingPartner.name }}</td>
                                    <td class="align-middle">{{ element.name }}</td>
                                    <td class="align-middle text-ellipsis" title="{{ getAddress(element) }}" style="max-width: 20em;">
                                        {{ getAddress(element) }}
                                    </td>
                                    <td class="align-middle">
                                        @if (element.identificationCodes.length > 0) {
                                            <span class="me-2">{{ getIdentifierDisplay(element.identificationCodes[0]!) }}</span>
                                            <ng-template #identifiersPopover>
                                                @for (code of element.identificationCodes; track code.id) {
                                                    <div>{{ getIdentifierDisplay(code) }}</div>
                                                }
                                            </ng-template>
                                            <span class="badge text-bg-primary rounded-pill" role="button" tabindex="0"
                                                  [ngbPopover]="identifiersPopover" popoverTitle="Identifiers" triggers="mouseenter:mouseleave focus:blur" placement="end">
                                                {{ element.identificationCodes.length }}
                                            </span>
                                        }
                                    </td>
                                    <td class="align-middle text-center">
                                        @if (element.isActive) {
                                            <i class="bi bi-check-lg text-success" aria-label="Active"></i>
                                        } @else {
                                            <i class="bi bi-x text-danger" aria-label="Inactive"></i>
                                        }
                                    </td>
                                    <td class="align-middle text-center">
                                        <div class="btn-group" role="group">
                                            <i class="btn btn-sm btn-outline-primary bi bi-pencil" (click)="onEdit(element)"></i>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>

                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                } @else if (loadFailed()) {
                    <div class="card text-center bg-danger-subtle border border-danger rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-x-octagon-fill me-2"></i>The distribution centers could not be loaded.
                            <div><button type="button" (click)="retry()" class="btn btn-primary mt-3">Try again</button></div>
                        </div>
                    </div>
                } @else {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No distribution centers found.
                            <div class="mt-3">
                                <button type="button" class="btn btn-sm btn-outline-primary" (click)="onAdd()">
                                    <i class="bi bi-building-add me-1"></i>Add Distribution Center
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>

        <app-distribution-center-modal #dcModal (saved)="onSaved($event)" />
    </div>
</div>
